import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Btn } from "@/components/Btn";

const PILLARS = [
  ["Design-led", "Everything begins with considered, premium design."],
  ["Commercially focused", "Beautiful work that exists to grow your business."],
  ["Transparent pricing", "Public prices. No quotes, no sales games."],
  ["Personal service", "You work directly with the studio, start to finish."],
];

export default function About() {
  return (
    <>
      <PageHero eyebrow="About" title="Premium design," accent="without the friction."
        subtitle="Wave Eleven is an independent digital design studio based in Poole, Dorset, working with ambitious businesses across the UK." />
      <section className="bg-paper text-ink">
        <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
          <div className="grid gap-12 md:grid-cols-12">
            <div className="md:col-span-5"><p className="text-[11px] uppercase tracking-label text-ink/40">Our philosophy</p></div>
            <div className="md:col-span-6 md:col-start-7">
              <Reveal><p className="font-serif text-2xl leading-snug tracking-tight md:text-3xl">Businesses should be able to access genuinely premium design — without confusing pricing, unnecessary agency process or endless sales conversations.</p></Reveal>
              <Reveal delay={0.1}><p className="mt-8 text-lg leading-relaxed text-ink/70">Wave Eleven combines premium design, clear pricing and a straightforward process. You see exactly what you're getting, exactly what it costs, and exactly what happens next.</p></Reveal>
              <Reveal delay={0.15}><p className="mt-6 text-base leading-relaxed text-ink/65">We keep the studio deliberately focused, so every project gets genuine attention and a direct line to the people designing and building it.</p></Reveal>
            </div>
          </div>
          <div className="mt-20 grid grid-cols-1 gap-x-12 gap-y-12 sm:grid-cols-2 md:grid-cols-4">
            {PILLARS.map(([t, c], i) => (
              <Reveal key={t} delay={i * 0.05}><div><span className="font-serif text-2xl text-champagne">{String(i + 1).padStart(2, "0")}</span><h3 className="mt-4 text-[11px] uppercase tracking-label">{t}</h3><p className="mt-3 text-sm leading-relaxed text-ink/65">{c}</p></div></Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-ink text-white"><div className="mx-auto max-w-[1440px] px-6 py-20 md:px-12 md:py-28"><div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center"><h2 className="font-serif text-3xl tracking-tight md:text-4xl">Based in Poole. Working across the UK.</h2><Btn to="/start" variant="gold" testid="about-cta">Start a Project</Btn></div></div></section>
    </>
  );
}
